<template>
  <div>
    <!-- for Modal Window Start -->
    <modal 
      name="modalview" 
      height="auto" 
      :resizable="false"
      :adaptive="false"
      :scrollable="true"
      >
      <div class="modal-header">
      </div>
      <div class="modal-body" style="text-align:center;">
        <Preview :val="mydata" ref="Preview" />
        <br />
        <button v-on:click="closePreview">入力画面に戻る</button>
      </div>  
    </modal>
    <!-- for Modal Window End -->
    <!-- Content Start -->
    <div class="col-md-6 offset-md-3 mb-5">
      <div class="thanks-form" style="text-align:center;">
        <h1><b>エントリーありがとうございました。</b></h1>
         <p class="thanks-form-content">
          ご記入いただいた履歴書は無事送信されました。<br />
          確認のためご記入者へ自動返信メールを送らせていただきました。<br />
          メールが届かない場合は、お手数ですが再度お問合せいただくか、弊社までご一報ください。
         </p>
      </div>
    </div>
  </div>
</template>

<script>
var API_TOKEN = process.env.VUE_APP_API_TOKEN
var API_BASE_URL = process.env.VUE_APP_API_BASE_URL

//import jsPDF from 'jspdf'
import axios from 'axios'
import FormData from 'form-data'
//import qs from 'qs'
//import pdfMake from 'pdfmake/build/pdfmake';
//import pdfFonts from 'pdfmake/build/vfs_fonts'
//import htmlToPdfmake from 'html-to-pdfmake'
//pdfMake.vfs = pdfFonts.pdfMake.vfs;
//pdfMake.fonts = {
//  ipa: {
//    normal: "ipagp.ttf",
//    bold: "ipagp.ttf"
//  }
//};

import Preview from '../components/Preview.vue'
import moment from 'moment'
var m = new moment()

export default {
  name: 'Content',
  components: {
    Preview,
  },
  computed: {
      isError: function () {
          return !!this.error !== ''
      },
      classesDragArea () {
          return {
              'drag-on': this.inArea
          }
      }
  },
  data() {
    const dateyears = [];
    const datemonths = [];
    const datedays = [];
    const timehours = [];
    const timeminutes = [];
    for (let i=1900; i<= m.format('YYYY'); i++ ) {
      dateyears.push({
        id: ('0000' + i).slice(-4),
        label: ('0000' + i).slice(-4)
      });
    }
    for (let i=1; i<=12; i++) {
      datemonths.push({
        id: ('00' + i).slice(-2),
        label: ('00' + i).slice(-2)
      });
    }
    for (let i=1; i<=31; i++) {
      datedays.push({
        id: ('00' + i).slice(-2),
        label: ('00' + i).slice(-2)
      });
    }
    for (let i=0; i<=23; i++) {
      timehours.push({
        id: ('00' + i).slice(-2),
        label: ('00' + i).slice(-2)
      });
    }
    for (let i=0; i<=59; i++) {
      timeminutes.push({
        id: ('00' + i).slice(-2),
        label: ('00' + i).slice(-2)
      });
    }
    return {
      errors: [],
      mydata: '',
      dateyears,
      datemonths,
      datedays,
      timehours,
      timeminutes,
      showPreview: false,
      sendingFlag: false,
      page: 1,
      indata: {
        fname: '',
        lname: '',
        fnamekana: '',
        lnamekana: '',
        sex: '男',
        birthdayyear: (Number(m.format('YYYY')) -20).toString(),
        birthdaymonth: '01',
        birthdayday: '01',
        age: (Number(m.format('YYYY')) - Number(m.add(-20, 'years').format('YYYY'))),
        huyonin: '',
        haigusyaumu: '無',
        haigusyahuyogimu: '無',
        tukintimehour: '00',
        tukintimeminute: '00',
        gen: {
          zipcode: '',
          prefname: '',
          address: '',
          address2: '',
          prefnamekana: '',
          addresskana: '',
          addresskana2: '',
          tel: '',
          email: '',
        },
        renraku: {
          zipcode: '',
          prefname: '',
          address: '',
          address2: '',
          prefnamekana: '',
          addresskana: '',
          addresskana2: '',
          tel: '',
          email: '',
        },
        gakusyokus: [
          {id: 1,year: '',month: '',content: ''},
          {id: 2,year: '',month: '',content: ''},
          {id: 3,year: '',month: '',content: ''},
          {id: 4,year: '',month: '',content: ''},
          {id: 5,year: '',month: '',content: ''},
          {id: 6,year: '',month: '',content: ''},
          {id: 7,year: '',month: '',content: ''},
          {id: 8,year: '',month: '',content: ''},
          {id: 9,year: '',month: '',content: ''},
          {id: 10,year: '',month: '',content: ''},
          {id: 11,year: '',month: '',content: ''},
          {id: 12,year: '',month: '',content: ''},
          {id: 13,year: '',month: '',content: ''},
          {id: 14,year: '',month: '',content: ''},
          {id: 15,year: '',month: '',content: ''},
          {id: 16,year: '',month: '',content: ''},
          {id: 17,year: '',month: '',content: ''},
          {id: 18,year: '',month: '',content: ''},
          {id: 19,year: '',month: '',content: ''},
          {id: 20,year: '',month: '',content: ''},
          {id: 21,year: '',month: '',content: ''},
          {id: 22,year: '',month: '',content: ''},
          {id: 23,year: '',month: '',content: ''}
        ],
        menkyosikakus: [
          {id: 1,year: '',month: '',content: ''},
          {id: 2,year: '',month: '',content: ''},
          {id: 3,year: '',month: '',content: ''},
          {id: 4,year: '',month: '',content: ''},
          {id: 5,year: '',month: '',content: ''},
          {id: 6,year: '',month: '',content: ''},
          {id: 7,year: '',month: '',content: ''},
          {id: 8,year: '',month: '',content: ''},
          {id: 9,year: '',month: '',content: ''},
          {id: 10,year: '',month: '',content: ''},
          {id: 11,year: '',month: '',content: ''},
          {id: 12,year: '',month: '',content: ''}
        ],
        sibodoki: '',
        honninkiboran: '',
        myphoto: {
          name: '',
          type: '',
          bindata: '',
        }
      }
    }
  },
  methods: {
    // ■次画面
    next() {
      if (this.checkForm(this.page)) {
        this.page++;
      }
    },
    // ■前画面
    prev() {
      this.page--;
    },
    // ■年齢計算
    calcAge() {
      let age =  (Number(moment().format('YYYY')) - Number(moment(this.indata.birthdayyear + '-' + this.indata.birthdaymonth + '-' + this.indata.birthdayday).format('YYYY')));
      this.indata.age = age
    },
    //■ エラーチェック
    checkForm: function (page) {
      this.errors = [];
      if (page == 1) {
        if ((!this.indata.fname) || (!this.indata.lname)) {
          this.errors.push("氏名を入力してください。");
        }
      } else if (page == 2) {
        if ((!this.indata.gen.tel) && (!this.indata.gen.email) && (!this.indata.renraku.tel) && (!this.indata.renraku.email)) {
          this.errors.push('現住所、連絡先の電話番号又はメールを入力してください。');
        } else if ((this.indata.gen.email.length > 0) && (!this.validEmail(this.indata.gen.email))) {
          this.errors.push('現住所メールの書式が正しくありません。');
        } else if ((this.indata.renraku.email.length > 0) && (!this.validEmail(this.indata.renraku.email))) {
          this.errors.push('連絡先メールの書式が正しくありません。');
        }
      } else if (page == 5) {
        if (!this.indata.sibodoki) {
          this.errors.push("志望動機を入力してください。");
        }
      } else if (page == 7) {
        if (!this.indata.myphoto.name) {
          this.errors.push("証明写真を選択してください。");
        }
      }
      if (!this.errors.length) {
        return true
      }
      //e.preventDefault();
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    //■ 送信処理
    submit() {
      if (this.sendingFlag) {
        alert("送信処理中です。")
        return
      }
      if (!this.checkForm(7)) return;
      if (!confirm('入力した履歴書を送信します。よろしいですか?')) return
      this.sendingFlag = true;
      let formData = new FormData();
      formData.append('apitoken', API_TOKEN)

      //// 変数部
      Object.entries(this.indata).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            console.log(value)
        } else {
          formData.append(key, value)
        }
      })
      //// 配列部
      ////// 現住所
      Object.entries(this.indata.gen).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((v, i) => {
            console.log(i)
            formData.append(key + '[]', v)  // arrayデータを分割して入れ直す
          })
        } else {
          formData.append('gen[' + key + ']', value)
        }
      })
      ////// 連絡先
      Object.entries(this.indata.renraku).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((v, i) => {
            console.log(i)
            formData.append(key + '[]', v)  // arrayデータを分割して入れ直す
          })
        } else {
          formData.append('renraku[' + key + ']', value)
        }
      })
      ////// 学歴・職歴
      for(let ix=0;ix<23;ix++) {
        Object.entries(this.indata.gakusyokus[ix]).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((v, i) => {
              console.log(i)
              formData.append(key + '[]', v)  // arrayデータを分割して入れ直す
            })
          } else {
            formData.append('gakusyokus[' + ix + '][' + key + ']', value)
          }
        })
      }
      ////// 免許・資格
      for(let ix=0;ix<12;ix++) {
        Object.entries(this.indata.menkyosikakus[ix]).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((v, i) => {
              console.log(i)
              formData.append(key + '[]', v)  // arrayデータを分割して入れ直す
            })
          } else {
            formData.append('menkyosikakus[' + ix + '][' + key + ']', value)
          }
        })
      }
      ////// 証明写真
      Object.entries(this.indata.myphoto).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((v, i) => {
            console.log(i)
            formData.append(key + '[]', v)  // arrayデータを分割して入れ直す
          })
        } else {
          formData.append('myphoto[' + key + ']', value)
        }
      })
      var file = document.getElementById("file")
      formData.append("facefile", file.files[0]);

      let config = {
        method: 'post',
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
      let url = API_BASE_URL + 'index.php'
      axios.post(url, formData, config)
      .then(res => {
        alert(res.data.status.message);
        this.sendingFlag = false;
      }).catch(error => {
        console.log(error);
        this.sendingFlag = false;
      });
    },
    navigationCss(targetPage) {
        if(this.page === targetPage) {  // 現在ページの場合
            return ['text-center', 'text-white', 'bg-info'];
        }
        return ['text-center', 'text-secondary'];
    },
    // 画像ファイル操作関連
    setImage(e) {
      console.log(e);
      this.errors = [];
      const files = this.$refs.file;
      const fileImg = files.files[0];
      if (fileImg.type.startsWith("image/")) {
       this.indata.myphoto.bindata = window.URL.createObjectURL(fileImg);
        this.indata.myphoto.name = fileImg.name;
        this.indata.myphoto.type = fileImg.type;
      }
    },
    dropFile(e) {
        this.changeFile(e)
        this.offArea()
    },
    changeFile (e) {
        const files = e.target.files || e.dataTransfer.files

        if (this.validation(files[0])) {
            this.file = files[0]
        } else {
            this.file = {}
        }
    },
    resetFile () {
        const input = this.$refs.file;
        input.type = 'text'
        input.type = 'file'
        this.file = {}
        this.error = ''
    },
    validation (file) {
        if (!this.isAllowFileType(file.type)) {
            this.error = this.getErrorMessageType()
            return false
        }

        if (!this.isAllowFileSize(file.size)) {
            this.error = this.getErrorMessageSize()
            return false
        }

        this.error = ''
        return true
    },
    onArea  () { this.inArea = true  },
    offArea () { this.inArea = false },

    // プレビュー関連
    openPreview : function() {
      console.log(this.$modal)
       this.mydata = this.indata
       this.$modal.show('modalview');
    },
    closePreview : function () {
      this.$modal.hide('modalview');
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
/* ファイル操作関連 */
.drag-label {
    font-size: 12px;
    padding: 2px 3px;
}
.drag-label:hover {
    cursor: pointer;
}
.drag-label input {
    display: none;
}
#file_name {
    font-size: 14px;
    margin-left: 20px;
}
.reset_file_ico {
    padding: 0 4px;
    font-size: 12px;
    border: 1px solid #c6c6c6;
    border-radius: 10px;
}
.reset_file_ico:hover {
    cursor: pointer;
    border-color: #5f6674;
}
#error {
    color: #d70035;
}
.drop-area {
    width: 300px;
    padding: 10px;
    text-align: center;
    border: 1px dashed #1f1a1a;
    background-color: #f9f9f9;
}
.drag-on {
    border: 2px dashed #bcbcbc;
    background-color: #fafdff;
}

input[type="radio"] {
	width: +2em;
	height: +2em;
  margin-right: 2px;
}
.form-leftlabel {
  margin-top: 10px;
}
.form-addlabel {
  margin-right:16px;
  margin-top: 10px;
}
h2.subtitle {
  padding-top: 8px;
    padding-bottom: 8px;
    font-size: 18px;
    font-weight: 700;
}
</style>
